import { ErrorCode } from '@constants/errorCodes';
import { ApiError } from '@types';

type SaveLeadMode = 'edit' | 'create';

export type SaveLeadErrorOptions = {
  updateContext?: 'assignee';
};

const LEAD_ERROR_MESSAGES = {
  forbidden: {
    edit: "You don't have permission to update this lead.",
    create: "You don't have permission to create a lead.",
    assignee: "You don't have permission to update assignee."
  },
  default: {
    edit: 'Failed to update lead. Please try again.',
    create: 'Failed to create lead. Please try again.',
    assignee: 'Failed to update assignee. Please try again.'
  }
} as const;

function resolveForbiddenTier(error: unknown): 'forbidden' | 'default' {
  const apiError = error as ApiError;
  return apiError?.data?.errorCode === ErrorCode.ERR_FORBIDDEN
    ? 'forbidden'
    : 'default';
}

export default function getSaveLeadErrorMessage(
  error: unknown,
  isEditMode: boolean,
  options?: SaveLeadErrorOptions
): string {
  const mode: SaveLeadMode = isEditMode ? 'edit' : 'create';
  const tier = resolveForbiddenTier(error);
  if (options?.updateContext === 'assignee') {
    return LEAD_ERROR_MESSAGES[tier].assignee;
  }
  return LEAD_ERROR_MESSAGES[tier][mode];
}
